import { getNumberFormatter } from 'components/widget/AuthorsWidgets/share/Table/utils'
import { MessageConst } from 'enums'

const formatMentionsDisplay = (mentions: number | undefined) => {
  if (mentions || mentions === 0) {
    return getNumberFormatter().format(mentions)
  }
  return MessageConst.EM_DASH
}

export default formatMentionsDisplay
